import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { IRouter } from '../shared/interfaces/router.interface';
import {
  TRACKED_TIMES_BILLED_ROUTE,
  TRACKED_TIMES_UNBILLED_ROUTE,
} from '../tracked-times/tracked-times.constant';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingObject,
  TrackingButtonIdentifierEnum,
  TrackingScreenNamesEnum,
} from '../tracking/tracking.data';

@Injectable()
export class TrackedTimeMasterBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildFilterRoutes(
    trackingObject: ITrackingObject,
    trackingScreenName: TrackingScreenNamesEnum
  ): List<IRouter> {
    return List([
      {
        label: 'TRACKED_TIME.TABS.UNBILLED',
        route: [TRACKED_TIMES_UNBILLED_ROUTE],
        trackingObject,
        trackingAction: this._trackingActionBuilder.buildTabTapped(
          'unbilled',
          trackingScreenName
        ),
        e2eId: 'unbilled-tracked-times-tab',
      },
      {
        label: 'TRACKED_TIME.TABS.BILLED',
        route: [TRACKED_TIMES_BILLED_ROUTE],
        trackingObject,
        trackingAction: this._trackingActionBuilder.buildTabTapped(
          'billed',
          trackingScreenName
        ),
        e2eId: 'billed-tracked-times-tab',
      },
    ]);
  }

  buildPrimaryAction(
    trackingObject: ITrackingObject,
    trackingScreenName: TrackingScreenNamesEnum,
    buttonIdentifier: TrackingButtonIdentifierEnum,
    disabled?: boolean
  ): IRouter {
    return {
      label: this._translateService.instant('ACTION.TRACK_TIME'),
      route: null,
      trackingObject,
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        buttonIdentifier,
        trackingScreenName
      ),
      e2eId: 'add-tracked-time-action',
      disabled,
    };
  }
}
